import { SessionsPlansMap } from '@landr/pricing';

const getCheckoutReturnPath = (code: string) => {
    const params = new URLSearchParams('');
    if (Object.values(SessionsPlansMap).includes(code as SessionsPlansMap)) {
        params.set('returnPath', '/sessions');
        return `?${params.toString()}`;
    }
    return '';
};

export const getCheckoutLinkFromPlanCode = (code: string, frequency: string, couponCode?: string) => {
    let pathname = `/payment/subscription/checkout/${code}/${frequency}`;

    if (couponCode) {
        pathname += `/${couponCode}`;
    }
    if (code === SessionsPlansMap.Free) {
        return `${process.env.GATSBY_APP_ENDPOINT}/sessions`;
    }

    return `${process.env.GATSBY_APP_ENDPOINT}${pathname}${getCheckoutReturnPath(code)}`;
};
